import React from 'react';
import { DashboardHook } from './reducer';
import { SpinnerArea, Table, TablePagination } from '../../shared/components';
import getCells from './Cells';

interface Props {
  hook: DashboardHook;
  send: (type: string, rest?: Record<string, unknown>) => void;
}

const ListView: React.FC<Props> = ({ hook, send }) => {
  const [data, loading, filter] = hook;

  const changePage = (page: number) => send('PAGE', { value: page });

  const changePageSize = (size: number) => send('PAGE_SIZE', { value: size });

  const setColumnOrder = (sortField: string, sortDescending: boolean) =>
    send('ORDER', { column: sortField, descending: sortDescending });

  return (
    <div>
      <SpinnerArea loading={loading}>
        {data && (
          <>
            <Table
              data={data.list}
              cells={getCells(filter.phase)}
              keyFunc={(x) => x.id}
              sortData={filter}
              changeSort={setColumnOrder}
            />
            <TablePagination
              pageSize={filter.pageSize}
              pageNumber={filter.pageNumber}
              total={data.total}
              onChangePage={changePage}
              onChangeSize={changePageSize}
            />
          </>
        )}
      </SpinnerArea>
    </div>
  );
};

export default ListView;
